import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Invitations {
    invitations: any;
    next: string | null;
    previous: string | null;
    count: number | null;
    totalPages: number | null;
    isLoading: Boolean;
    error: string | null;
}

const initialState: Invitations = {
    invitations: [],
    next: null,
    previous: null,
    count: 0,
    totalPages: 0,
    isLoading: false,
    error: null,
};

const sentInvitationListSlice = createSlice({
    name: 'sentInvitationList',
    initialState,
    reducers: {
        setInvitationList: (state: Invitations, action: PayloadAction<Invitations>) => {
            state.invitations = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        setPagination: (state: Invitations, action: PayloadAction<Invitations>) => {
            state.next = action.payload.next;
            state.previous = action.payload.previous;
            state.count = action.payload.count;
            state.totalPages = Math.ceil((action.payload.count ?? 0) / 12);
            state.isLoading = false;
            state.error = null;
        },
        isloading: (state: Invitations, action: PayloadAction<Boolean>) => {
            state.isLoading = action.payload;
            state.error = null;
        },
        seterror: (state: Invitations, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        resetInvitationList: () => {
            return initialState;
        },
    },
});

export const { setInvitationList, setPagination, isloading, seterror, resetInvitationList } = sentInvitationListSlice.actions;

export default sentInvitationListSlice.reducer;
